export const REQUEST_CONFIGURATION = 'REQUEST_CONFIGURATION'
export const CONFIGURATION_RECEIVED = 'CONFIGURATION_RECEIVED'

export const QUERY_NEWS = 'QUERY_NEWS'
export const NEWS_RECEIVED = 'NEWS_RECEIVED'

export const FETCH_POSTS = 'FETCH_POSTS'
export const QUERY_POSTS = 'QUERY_POSTS'
export const POSTS_RECEIVED = 'POSTS_RECEIVED'

export const SEND_FEEDBACK = 'SEND_FEEDBACK'
export const SUBMIT_FORM = 'SUBMIT_FORM'

export const REQUEST_SUBSCRIBE_NEWS = 'REQUEST_SUBSCRIBE_NEWS'
export const SUBSCRIBE_NEWS_SUCCEEDED = 'SUBSCRIBE_NEWS_SUCCEEDED'

export const REQUEST_SUBSCRIBE_OFFERS = 'REQUEST_SUBSCRIBE_OFFERS'
export const SUBSCRIBE_OFFERS_SUCCEEDED = 'SUBSCRIBE_OFFERS_SUCCEEDED'
